import { SelectPicker } from "rsuite";

import FieldTypeFiles from "./FieldTypeFiles";

const ImageOptions = [
  {
    label: "Logo - Square Image with Dynamic Width",
    value: "Logo",
  },
  { label: "Avatar - Circular Image with Replacement Avatar", value: "Avatar" },
];

const FieldTypeImage = ({ fieldValues, setFieldValues }) => {
  // TODO: Replace SelectPicker with Workflow IconCards when workflows is merged.
  return (
    <>
      <h4 className="mb-0">Image Presentation Mode</h4>
      <p className="mb-4">
        <small>Select the way this image should be presented</small>
      </p>
      <SelectPicker
        block
        placeholder="Select Presentation Mode"
        value={fieldValues?.presentation ?? ""}
        searchable={false}
        data={ImageOptions}
        onChange={(mode) =>
          setFieldValues((prev) => ({ ...prev, presentation: mode }))
        }
      />
      <FieldTypeFiles
        fieldValues={fieldValues}
        setFieldValues={setFieldValues}
        containerCSS="pt-3"
      />
    </>
  );
};

export default FieldTypeImage;
